import { BodyText, Box, Flex } from '@utilitywarehouse/hearth-react';

import { ProductType } from '@generated/gql/graphql';

import { TierRoundel } from './TierRoundel';
import { TierService } from './TierService';
import { Tier } from './tiers';

interface TierRowProps {
  tier: Tier;
  tierServices: ProductType[];
}

const TierRow = ({ tier, tierServices }: TierRowProps) => {
  const reached = tierServices.length >= tier.count;

  return (
    <Flex gap="100" alignItems="center" width="100%" paddingY="50">
      <TierRoundel reached={reached} />
      <Box flex="1" minWidth="0">
        <BodyText size="sm" weight={reached ? 'semibold' : 'regular'}>
          {reached ? tier.unlockedLabel : tier.lockedLabel}
        </BodyText>
      </Box>

      <Flex direction="row" flexShrink="0" alignItems="center">
        <TierService tierServices={tierServices} tier={tier} />
      </Flex>
    </Flex>
  );
};

export { TierRow };
